import { PhoneIcon, WhatsAppIcon } from './Icons';

export default function FloatingCTA() {
  return (
    <div className="floating-cta">
      <a href="tel:+97100000000" className="float-call">
        <PhoneIcon size={15} color="white" />
        Call Now
      </a>
      <a
        href="https://wa.me/97100000000?text=Hi,%20I'd%20like%20to%20book%20a%20home%20physiotherapy%20visit"
        target="_blank" rel="noopener noreferrer"
        className="float-wa"
      >
        <WhatsAppIcon size={15} color="white" />
        WhatsApp
      </a>
    </div>
  );
}
